export var WalletType;
(function (WalletType) {
    WalletType["BTC"] = "BTC";
    WalletType["EVM"] = "EVM";
})(WalletType || (WalletType = {}));
